/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export default (props: { className: string; msg?: string }) => (
    <>
        <div className={`${props.className}__loading__icon`} />
        {props?.msg && <div className={`${props.className}__loading__msg`}>{props?.msg}</div>}
    </>
);
